export enum InvoiceStatus {
  Sent = 'sent',
  Paid = 'paid',
  Cancelled = 'cancelled',
}

export type Invoice = {
  number: string
  date: string
  amount: number
  status: InvoiceStatus
  url: string
}
